import { useRef, useState } from "react";
import { Input } from "@/components/ui/input";

function formatAsCurrency(value: string | number): string {
  const num = typeof value === "string" ? Number.parseFloat(value) : value;
  if (Number.isNaN(num)) return "";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(num);
}

export function CurrencyInput({
  id,
  value,
  onChange,
  onBlur,
  placeholder,
  autoFocus,
  className,
  disabled,
}: {
  id: string;
  value: string | number;
  onChange: (value: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  autoFocus?: boolean;
  className?: string;
  disabled?: boolean;
}) {
  const [focused, setFocused] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const displayValue = focused || value === "" ? String(value) : formatAsCurrency(value);

  return (
    <Input
      ref={inputRef}
      id={id}
      type={focused ? "number" : "text"}
      value={displayValue}
      onChange={(e) => onChange(e.target.value)}
      onFocus={() => setFocused(true)}
      onBlur={() => {
        setFocused(false);
        onBlur?.();
      }}
      placeholder={placeholder}
      autoFocus={autoFocus}
      className={className}
      disabled={disabled}
    />
  );
}
